<template>
  <ContentInfoLinks :links="links" />
</template>

<script>
import ContentInfoLinks from 'chimera/all/themes/blueflow/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          title: 'Algemeen',
          to: '/informatie-over-accountants/',
        },
        {
          title: 'Particulieren accountant',
          to: '/informatie-over-accountants/accountants-voor-particulieren',
        },
        {
          title: 'Bedrijven accountant',
          to: '/informatie-over-accountants/accountants-voor-bedrijven',
        },
        {
          title: 'AA-accountant',
          to: '/informatie-over-accountants/aa-accountant',
        },
        {
          title: 'RA-accountant',
          to: '/informatie-over-accountants/ra-accountant',
        },
      ],
    }
  },
}
</script>
